export default __webpack_public_path__ + "static/img14-990e3a43b930cea5efc3c31975cad63a.png";